import {
  Card,
  CardDescription,
  CardHeader,
  CardList,
  CardListRow,
  CardTitle,
} from '@/components/ui/Card'
import { Progress } from '@/components/ui/Progress'
import { ActivityList, DauChart } from '@/components/overview'
import { PageHeader, StatCard } from '@/components/shared'
import { ACTIVITY, DAU_SERIES, REGIONS, STATS, TOP_CARDS } from '@/fixtures'

export function OverviewPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Overview" description="Live health of the game across all regions." />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((stat) => (
          <StatCard key={stat.id} stat={stat} />
        ))}
      </div>

      {/* 8 / 4: analytics on the left, feeds on the right. */}
      <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-12">
        <div className="space-y-6 lg:col-span-8">
          <Card>
            <CardHeader>
              <div className="min-w-0">
                <CardTitle>DAU Growth · Last 30 Days</CardTitle>
                <CardDescription>
                  Daily active user volume trends across all servers.
                </CardDescription>
              </div>
            </CardHeader>
            <div className="px-5 pt-4 pb-3">
              <DauChart series={DAU_SERIES} labels={['Jul 28', 'Aug 11', 'Aug 26']} />
            </div>
          </Card>

          <Card>
            <CardHeader>
              <div className="min-w-0">
                <CardTitle>Top Cards by Usage</CardTitle>
                <CardDescription>
                  Most selected battle cards across ranked deck builds.
                </CardDescription>
              </div>
            </CardHeader>
            <CardList>
              {TOP_CARDS.map((card) => (
                <CardListRow key={card.id} className="gap-4">
                  <span className="text-fg min-w-0 flex-1 truncate text-sm font-semibold">
                    {card.name}
                  </span>
                  <Progress value={card.usage} max={40} className="w-28 shrink-0" />
                  <span className="text-fg-subtle w-12 shrink-0 text-right text-sm tabular-nums">
                    {card.usage}%
                  </span>
                </CardListRow>
              ))}
            </CardList>
          </Card>
        </div>

        <div className="space-y-6 lg:col-span-4">
          <Card>
            <CardHeader>
              <div className="min-w-0">
                <CardTitle>Recent Activity</CardTitle>
                <CardDescription>Real-time admin &amp; player audit feed.</CardDescription>
              </div>
            </CardHeader>
            <ActivityList entries={ACTIVITY} />
          </Card>

          <Card>
            <CardHeader>
              <div className="min-w-0">
                <CardTitle>Players by Region</CardTitle>
                <CardDescription>Geographic distribution of global active players.</CardDescription>
              </div>
            </CardHeader>
            <CardList>
              {REGIONS.map((region) => (
                <CardListRow key={region.id}>
                  <span className="text-fg min-w-0 flex-1 truncate text-sm font-semibold">
                    {region.region}
                  </span>
                  <Progress value={region.share} className="w-20 shrink-0" />
                  <span className="text-fg-subtle w-16 shrink-0 text-right text-sm tabular-nums">
                    {region.players}
                  </span>
                </CardListRow>
              ))}
            </CardList>
          </Card>
        </div>
      </div>
    </div>
  )
}
